function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export const MailSentLine18 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 6.375C1.5 3 2.25 2.625 5.25 2.625H12.75C15.75 2.625 16.5 3 16.5 6.375V11.625C16.5 15 15.75 15.375 12.75 15.375H5.25M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75M1.5 12.375H6M1.5 9.375H3.75",
  stroke: "#696992",
  strokeWidth: "1.1",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));